class DDBoolean extends React.Component {

    render() {
        var label = this.props.label || ['Yes', 'No'];

        return (
            <select
                value={this.props.value}
                className='dd-base'
                onChange={e => { this.props.onChange(e.target.value === 'true' ? true : false); }}>

                <option value={true}>
                    {label[0]}
                </option>

                <option value={false}>
                    {label[1]}
                </option>
            </select>
        );
    }
}

export default DDBoolean;


// WEBPACK FOOTER //
// ./ui_src/app/components/form/dropdown/DDBoolean.react.jsx